import { Button, Form, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { FC, useState } from 'react';

import { openNotification } from '../../../../common/helpers';
import { NotificationTypes } from '../../../../common/interfaces';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { downloadFile } from '../Documents.helpers';
import styles from './TemplatesDoc.module.scss';

type Props = {
  name?: string;
  getFileBase64: any; // mutation function
  isLoading: boolean;
};

export const TemplatesDoc: FC<Props> = ({ getFileBase64, isLoading }) => {
  const { templates } = useTypedSelector((state) => state.registration);
  const [form] = useForm();

  const initialValues = {
    templateId: templates?.[0]?.value ?? '',
  };

  const handleSubmit = async (values: { templateId: string }) => {
    try {
      const res = await getFileBase64({
        fileId: values.templateId,
      }).unwrap();

      if (res.data) {
        downloadFile(res);
      }
    } catch (e) {
      openNotification(
        NotificationTypes.ERROR,
        `Ошибка при скачивании файла: ${e}`,
      );
      console.error(e);
    }
  };

  return (
    <Form
      className={styles.form}
      initialValues={initialValues}
      onFinish={handleSubmit}
      layout="vertical"
      form={form}
    >
      <label className={styles.label}>Шаблоны документов</label>

      <div className={styles.container}>
        <Form.Item className={styles.select} name="templateId">
          <Select options={templates} />
        </Form.Item>

        <Button loading={isLoading} htmlType="submit">
          Скачать
        </Button>
      </div>
    </Form>
  );
};
